<div>
    <p></p>
    <h3>
        General
    </h3>
    <p></p>
</div>
<div>
    <p>
        Submission Platform (this “Tool”) is developed and maintained by
        Deloitte Global Tax Center (Europe) BV BE ovve CVBA with registered
        office at Gateway building, Luchthaven nationaal 1 J, B-1930 Zaventem,
        Belgium (the “Deloitte Belgium”, “DGTCE”, “we,” “us” or “our”). This
        Tool can be used by personnel from other entities in the Deloitte
        Network, and these Terms of Use govern your use of this Tool. When used
        in these Terms, the “Deloitte Network” refers to Deloitte Touche
        Tohmatsu Limited (“DTTL”), the member firms of DTTL, and their related
        entities.
    </p>
</div>
<div>
    <p>
        This Tool is licensed to your member firm as “Shared IP” under the
        Shared Intellectual Property License Agreement among your member firm,
        Deloitte IPCO LLC, and certain other parties (the “IPCO Agreement”).
        This Tool is subject to the Category A Standard Use Restriction under
        the IPCO Agreement, which, in general, allows you and your member firm
        to use this Tool for internal purposes only without the possibility to
        create any Enhancements. A copy of the IPCO Agreement can be found 
        <a
            href="https://global.deloitteresources.com/resource/KM/Documents/Shared%20ip%20agreement_final_928277.pdf"
            target="_blank"
            rel="noreferrer noopener"
        >
            here
        </a>
        . Please direct any questions you may have about the IPCO Agreement to
        your member firm’s legal group.
    </p>
</div>
<div>
    <div>
    </div>
    <div>
        <p></p>
        <h3>
            Compliance With Laws and Your Member Firm’s Policies
        </h3>
        <p></p>
    </div>
    <div>
        <p>
            When using this Tool, you must also comply with the following (as
            applicable):
        </p>
    </div>
    <div>
        <ul>
            <li>
                <p>
                    Your member firm’s rules and policies, including any rules
                    or policies that your member firm has adopted with respect
                    to this Tool;
                </p>
            </li>
            <li>
                <p>
                    All laws, regulations, and rules (including any
                    professional secrecy laws or data privacy laws) applicable
                    to your member firm’s use of this Tool;
                </p>
            </li>
        </ul>
    </div>
</div>
<div>
    <div>
        <ul>
            <li>
                <p>
                    Your member firm rules and policies, including all rules
                    and policies that govern the treatment of confidential,
                    proprietary, or personal information;
                </p>
            </li>
            <li>
                <p>
                    The terms of any applicable client engagement or services
                    agreement or any other applicable third party agreement;
                    and
                </p>
            </li>
            <li>
                <p>
                    Any additional license terms or IPCO Agreement Use
                    Restrictions applicable to such material.
                </p>
            </li>
        </ul>
    </div>
    <div>
        <p>
            In addition, your member firm may limit your access to certain
            sections of this Tool. If so, you may access and use only those
            sections, and you shall not access any other section or content in
            this Tool.
        </p>
    </div>
    <div>
    </div>
</div>
<div>
    <p></p>
    <h3>
        Personal Information
    </h3>
    <p></p>
</div>
<div>
    <p>
        Please review the Privacy Statement for more information regarding the
        ways in which your personal information is collected in connection with
        your use of this Tool, the purposes for which your personal information
        is used, and how it is shared.
    </p>
</div>
<div>
</div>
<div>
    <p></p>
    <h3>
        Revisions
    </h3>
    <p></p>
</div>
<div>
    <p>
        These Terms of Use may be revised from time to time. Such revised Terms
        of Use shall be effective to you upon posting here or elsewhere in this
        Tool, unless otherwise explicitly stated. You are responsible for being
        aware of, and complying with, any such revised Terms of Use. If you do
        not agree with any part of the Terms of Use (as revised from time to
        time), you must terminate your use of this Tool.
    </p>
</div>
<div>
</div>
<div>
    <p></p>
    <h3>
        Trademark
    </h3>
    <p></p>
</div>
<div>
    <p>
        “Deloitte”, “Touche”, “Tohmatsu”, “Deloitte Touche Tohmatsu”, “Deloitte
        &amp; Touche”, the Deloitte logo, and local language variants of the
        foregoing trademarks, and certain product names that appear in or on
        this Tool are trademarks or registered trademarks of entities within
        the Deloitte Network. All other product names mentioned in this Tool
        are the trademarks of their respective owners and are mentioned for
        identification purposes only.
    </p>
</div>
<div>
</div>
<div>
</div>
<div>
    <p></p>
    <h3>
        Hosting of this Tool
    </h3>
    <p></p>
</div>
<div>
    <p>
        If a member firm is going to self-host this Tool, then such member firm
        may need to acquire additional software licenses. Please contact
        Patrick Joucken (pjoucken@deloitte.com) at DGTCE for a list of such
        additional software licenses.
    </p>
</div>
<div>
</div>